import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setModalState } from "@/app_redux/reducers/modal_reducer";
import { setModalStateData } from "@/app_redux/reducers/modal_state_reducer";
import { ModalReducerStateIdKeys } from "@/app_redux/reducers/reducer_interface";
import { useModal } from "./useModal";

export const useModalActions = (modalId: ModalReducerStateIdKeys) => {
  const dispatch = useAppDispatch();
  const modalState = useModal(modalId);

  const setVisible = () => {
    dispatch(
      setModalState({
        key: modalId,
        status: true,
      }),
    );
  };

  const setInvisible = () => {
    dispatch(
      setModalState({
        key: modalId,
        status: false,
      }),
    );
    /* Empty the state when the modal is set invisible */
    // dispatch(
    //   setModalStateData({
    //     key: modalId,
    //     data: {},
    //   }),
    // );
  };

  const isVisible = () => {
    return modalState;
  };

  const toggle = () => {
    dispatch(
      setModalState({
        key: modalId,
        status: !modalState,
      }),
    );
  };

  const setModalData = (data: any) => {
    dispatch(
      setModalStateData({
        key: modalId,
        data: data,
      }),
    );
  };

  return {
    setVisible,
    setInvisible,
    toggle,
    setModalData,
    isVisible,
  };
};
